module.exports = __webpack_public_path__ + "img/pro_one_5.20c89982.jpg";